import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import Dropdown from '@/components/common/Dropdown.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import { EditorModule } from '@/store/modules/editor'
  import useIcons from '@/composables/useIcons'
  import useI18n from '@/composables/useI18n'
  import type { PropType } from 'vue'
  import type { Author } from '@/services/interfaces/Common'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EditAuthors',
  props: {
    authors: {
      type: Array as PropType<Author[]>,
      required: true,
    },
    authorText: {
      type: String,
      default: 'Author',
    },
    authorSubtext: {
      type: String,
      default: '',
    },
    addAuthorText: {
      type: String,
      default: '',
    },
    addAuthor: {
      type: Function as PropType<(authorId: string) => void>,
      required: true,
    },
    removeAuthor: {
      type: Function as PropType<(authorId: string) => void>,
      required: true,
    },
    canAddMoreAuthors: {
      type: Boolean,
      default: true,
    },
  },
  setup(__props) {

const props = __props;

  

  const { trashIcon } = useIcons()
  const { translateString } = useI18n()

  const allAuthors = computed(() => {
    if (!EditorModule.editorAllAuthors) return []
    return EditorModule.editorAllAuthors.map((author) => ({
      type: author.id,
      title: author.name,
      selectable: authorIsSelected.value(author.id),
    }))
  })

  const authorIsSelected = computed(() => {
    return (authorId: string) => {
      return !props.authors.find((a) => a.id === authorId)
    }
  })

  const showAddAuthor = computed(() => (props.canAddMoreAuthors ? true : props.authors.length === 0))

  const getAddAuthorText = computed(() => {
    return props.addAuthorText ? props.addAuthorText : translateString('editor.addAuthor')
  })

return { __sfc: true,props, trashIcon, translateString, allAuthors, authorIsSelected, showAddAuthor, getAddAuthorText, computed, Dropdown, SVGRenderer, EditorModule, useIcons, useI18n }
}

})